(function () {
  'use strict';

  if (window.__rssOrderAutoLoaded) return;
  window.__rssOrderAutoLoaded = true;

  var modal = document.querySelector('[data-rss-order-auto]');
  if (!modal) return;

  var endpoint = String(modal.getAttribute('data-order-endpoint') || '').trim();
  var pricingScriptUrl = String(
    modal.getAttribute('data-pricing-script-url') || ''
  ).trim();
  var pricingLoadPromise = null;
  var whatsappNumber = String(
    modal.getAttribute('data-whatsapp-number') || ''
  ).replace(/[^\d]/g, '');

  /* Calculator support: any whole quantity 1B…MAX_QTY (default 100T; above 1T
     every order is priced at the 1T rate by RSSPricing).
     Optional: add data-max-qty="1000" on the [data-rss-order-auto] dialog. */
  var MIN_QTY = 1;
  var MAX_QTY = Number(modal.getAttribute('data-max-qty')) || 100000;

  var detailsState = modal.querySelector('[data-rss-order-details]');
  var loadingState = modal.querySelector('[data-rss-order-loading]');
  var successState = modal.querySelector('[data-rss-order-success]');
  var errorState = modal.querySelector('[data-rss-order-error]');
  var detailsForm = modal.querySelector('[data-rss-order-details-form]');
  var serverInput = modal.querySelector('[data-rss-order-server]');
  var playerInput = modal.querySelector('[data-rss-order-player]');
  var contactMethodInput = modal.querySelector('[data-rss-order-contact-method]');
  var contactInput = modal.querySelector('[data-rss-order-contact]');
  var live = modal.querySelector('[data-rss-order-live]');
  var retryButton = modal.querySelector('[data-rss-order-retry]');
  var whatsappButton = modal.querySelector('[data-rss-order-whatsapp]');
  var whatsappFallback = modal.querySelector(
    '[data-rss-order-whatsapp-fallback]'
  );

  var lastTrigger = null;
  var lastPayload = null;
  var lastClientOrderId = null;
  var busy = false;

  function setHidden(node, hidden) {
    if (node) node.hidden = hidden;
  }

  function showOnly(name) {
    setHidden(detailsState, name !== 'details');
    setHidden(loadingState, name !== 'loading');
    setHidden(successState, name !== 'success');
    setHidden(errorState, name !== 'error');
  }

  function isValidQty(qty) {
    return Number.isInteger(qty) && qty >= MIN_QTY && qty <= MAX_QTY;
  }

  function formatQty(qty) {
    qty = Number(qty);
    if (!Number.isFinite(qty)) return '';

    if (qty >= 1000 && qty % 100 === 0) {
      return String(qty / 1000) + 'T';
    }

    if (qty >= 1000 && Number.isInteger(qty)) {
      return qty.toLocaleString('en-US') + 'B';
    }

    if (!Number.isInteger(qty)) {
      return (Math.round(qty * 100) / 100) + 'B';
    }

    return qty + 'B';
  }

  function formatUSD(value, forceDecimals) {
    value = Number(value);
    if (!Number.isFinite(value)) return '';

    if (
      window.RSSPricing &&
      typeof window.RSSPricing.formatUSD === 'function'
    ) {
      return window.RSSPricing.formatUSD(value, !!forceDecimals);
    }

    if (forceDecimals) return '$' + value.toFixed(2);
    return Number.isInteger(value)
      ? '$' + value.toFixed(0)
      : '$' + value.toFixed(2).replace(/0$/, '');
  }

  /* Order name shown in the modal, WhatsApp and Discord.
     Packages: "500B RSS". Calculator odd amounts: "1B × 35 = 35B RSS"
     (sent by the Calculator CTA as data-rss-order-label). */
  var STANDARD_QTY = [1, 10, 100, 200, 500, 1000];

  function orderLabel(trigger, qty) {
    var explicit =
      trigger && trigger.getAttribute
        ? String(trigger.getAttribute('data-rss-order-label') || '').trim()
        : '';
    if (explicit && explicit.length <= 60) return explicit;
    if (STANDARD_QTY.indexOf(qty) !== -1) return formatQty(qty) + ' RSS';
    if (qty > 1000 && qty % 1000 === 0) {
      return '1T × ' + qty / 1000 + ' = ' + formatQty(qty) + ' RSS';
    }
    return '1B × ' + qty.toLocaleString('en-US') + ' = ' + formatQty(qty) + ' RSS';
  }

  function getSelectedCard(trigger) {
    var root =
      trigger && trigger.closest
        ? trigger.closest('[data-rss-selection-root]')
        : null;

    if (root) {
      var inside = root.querySelector(
        '[data-rss-package][aria-checked="true"]'
      );
      if (inside) return inside;
    }

    return (
      document.querySelector('[data-rss-package][aria-checked="true"]') ||
      document.querySelector('[data-rss-package][data-package-total="500"]')
    );
  }

  function getQty(trigger) {
    /* An explicit quantity on the trigger (Calculator CTA) always wins,
       so the Calculator never picks up the Packages section's selection. */
    var explicitQty =
      trigger && trigger.getAttribute
        ? Number(trigger.getAttribute('data-rss-order-qty'))
        : NaN;

    if (isValidQty(explicitQty)) {
      return explicitQty;
    }

    var card = getSelectedCard(trigger);
    var qty = card ? Number(card.getAttribute('data-package-total')) : 500;

    if (!Number.isFinite(qty)) qty = 500;
    return qty;
  }

  function ensurePricing() {
    if (
      window.RSSPricing &&
      typeof window.RSSPricing.computeOrder === 'function'
    ) {
      return Promise.resolve(window.RSSPricing);
    }

    if (pricingLoadPromise) return pricingLoadPromise;

    if (!pricingScriptUrl) {
      return Promise.reject(
        new Error('Pricing engine is not configured.')
      );
    }

    pricingLoadPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = pricingScriptUrl;
      script.async = true;
      script.setAttribute('data-rss-pricing-engine', '');

      script.addEventListener('load', function () {
        if (
          window.RSSPricing &&
          typeof window.RSSPricing.computeOrder === 'function'
        ) {
          resolve(window.RSSPricing);
        } else {
          reject(new Error('Pricing engine could not be initialized.'));
        }
      });

      script.addEventListener('error', function () {
        reject(new Error('Pricing engine could not be loaded.'));
      });

      document.head.appendChild(script);
    });

    return pricingLoadPromise;
  }

  function computeOrder(qty) {
    if (
      !window.RSSPricing ||
      typeof window.RSSPricing.computeOrder !== 'function'
    ) {
      throw new Error('Pricing engine is not available.');
    }

    return window.RSSPricing.computeOrder(qty);
  }

  function setAll(selector, text) {
    modal.querySelectorAll(selector).forEach(function (node) {
      node.textContent = text;
    });
  }

  function makeReference() {
    var bytes = new Uint32Array(2);

    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      bytes[0] = Math.floor(Math.random() * 0xffffffff);
      bytes[1] = Math.floor(Math.random() * 0xffffffff);
    }

    var now = new Date();
    var day =
      String(now.getUTCFullYear()) +
      String(now.getUTCMonth() + 1).padStart(2, '0') +
      String(now.getUTCDate()).padStart(2, '0');

    var random =
      bytes[0].toString(36).slice(-4).toUpperCase() +
      bytes[1].toString(36).slice(-4).toUpperCase();

    return 'RSS-' + day + '-' + random;
  }

  function openModal() {
    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }

    document.documentElement.classList.add('rss-order-auto-open');
  }

  function closeModal() {
    if (busy) return;

    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }

    document.documentElement.classList.remove('rss-order-auto-open');

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  function updateContactInput() {
    if (!contactInput || !contactMethodInput) return;

    if (contactMethodInput.value === 'Discord') {
      contactInput.placeholder = 'Discord username';
      contactInput.inputMode = 'text';
      contactInput.autocomplete = 'off';
    } else {
      contactInput.placeholder = '+84 865 081 526';
      contactInput.inputMode = 'tel';
      contactInput.autocomplete = 'tel';
    }
  }

  function renderDetailsPreview(payload, reference) {
    var order = payload.order;

    setAll('[data-rss-order-pre-reference]', reference);
    setAll('[data-rss-order-pre-package]', payload.label);
    setAll(
      '[data-rss-order-pre-total]',
      formatUSD(order.total, false)
    );
  }

  async function prepareOrder(trigger) {
    try {
      await ensurePricing();

      var qty = getQty(trigger);

      if (!isValidQty(qty)) {
        throw new Error(
          'Please choose an RSS amount between ' +
            formatQty(MIN_QTY) +
            ' and ' +
            formatQty(MAX_QTY) +
            '.'
        );
      }

      var order = computeOrder(qty);
      var reference = makeReference();

      lastPayload = {
        qty: qty,
        order: order,
        label: orderLabel(trigger, qty),
        source:
          (trigger && trigger.getAttribute &&
            trigger.getAttribute('data-rss-order-source')) ||
          'packages',
        server: '',
        playerName: '',
        contactMethod: '',
        contact: ''
      };
      lastClientOrderId = reference;

      renderDetailsPreview(lastPayload, reference);
      openModal();
      showOnly('details');
      updateContactInput();

      if (live) {
        live.textContent =
          'Order details form opened for ' + lastPayload.label + '.';
      }

      window.setTimeout(function () {
        if (serverInput) serverInput.focus();
      }, 40);
    } catch (error) {
      openModal();
      renderError(
        error && error.message
          ? error.message
          : 'Please select an RSS package first.'
      );
    }
  }

  function collectDetails() {
    var server = String(serverInput ? serverInput.value : '').trim();
    var playerName = String(playerInput ? playerInput.value : '').trim();
    var contactMethod = String(
      contactMethodInput ? contactMethodInput.value : ''
    ).trim();
    var contact = String(contactInput ? contactInput.value : '').trim();

    if (!server) {
      if (serverInput) serverInput.focus();
      throw new Error('Please enter your Evony server.');
    }

    if (server.length > 32) {
      if (serverInput) serverInput.focus();
      throw new Error('Evony server is too long.');
    }

    if (['WhatsApp', 'Discord'].indexOf(contactMethod) === -1) {
      if (contactMethodInput) contactMethodInput.focus();
      throw new Error('Please choose WhatsApp or Discord.');
    }

    if (contact.length < 2) {
      if (contactInput) contactInput.focus();
      throw new Error('Please enter your contact information.');
    }

    if (contact.length > 120) {
      if (contactInput) contactInput.focus();
      throw new Error('Contact information is too long.');
    }

    return {
      server: server,
      playerName: playerName.slice(0, 80),
      contactMethod: contactMethod,
      contact: contact
    };
  }

  function buildWhatsAppMessage(payload, reference) {
    var order = payload.order;

    return [
      'Hi, I’m following up on RSS order ' + reference + '.',
      '',
      'Order: ' + payload.label,
      'Price per 1B: ' + formatUSD(order.effective, true),
      'Total: ' + formatUSD(order.total, false),
      'Server: ' + payload.server,
      payload.playerName ? 'Player: ' + payload.playerName : '',
      'Preferred contact: ' +
        payload.contactMethod +
        ' ' +
        payload.contact,
      'Resource split: ' +
        formatQty(order.each) +
        ' each of Food, Lumber, Stone and Ore.',
      '',
      'Please confirm the delivery details. Payment is after delivery.'
    ]
      .filter(Boolean)
      .join('\n');
  }

  function refreshWhatsApp(payload, reference) {
    if (!payload || !reference || !whatsappNumber) return;

    var url =
      'https://wa.me/' +
      whatsappNumber +
      '?text=' +
      encodeURIComponent(buildWhatsAppMessage(payload, reference));

    if (whatsappButton) whatsappButton.href = url;
    if (whatsappFallback) whatsappFallback.href = url;
  }

  function renderSuccess(payload, reference, response) {
    var order = payload.order;

    setAll('[data-rss-order-reference]', reference);
    setAll('[data-rss-order-package]', payload.label);
    setAll(
      '[data-rss-order-rate]',
      formatUSD(order.effective, true)
    );
    setAll(
      '[data-rss-order-total]',
      formatUSD(order.total, false)
    );
    setAll(
      '[data-rss-order-save]',
      formatUSD(order.discount, false)
    );
    setAll('[data-rss-order-each]', formatQty(order.each));
    setAll('[data-rss-order-success-server]', payload.server);
    setAll(
      '[data-rss-order-success-contact]',
      payload.contactMethod + ': ' + payload.contact
    );

    var status = modal.querySelector('[data-rss-order-status]');
    if (status) {
      status.textContent =
        response && response.discordSent === false
          ? 'Your order is saved in Shopify. The Discord notification was delayed, but the order itself is safe.'
          : 'Your order is saved. We will continue with you using the contact details above.';
    }

    refreshWhatsApp(payload, reference);
    showOnly('success');

    if (live) {
      live.textContent = 'Order ' + reference + ' saved.';
    }
  }

  function renderError(message) {
    var errorText = modal.querySelector(
      '[data-rss-order-error-text]'
    );

    if (errorText) {
      errorText.textContent =
        message ||
        'We could not save the order. Please try again.';
    }

    if (lastPayload && lastClientOrderId) {
      refreshWhatsApp(lastPayload, lastClientOrderId);
    }

    showOnly('error');

    if (live) {
      live.textContent = 'Order could not be saved.';
    }
  }

  async function sendOrder(reuseReference) {
    if (busy || !lastPayload) return;
    busy = true;

    try {
      if (!reuseReference) {
        var details = collectDetails();

        lastPayload.server = details.server;
        lastPayload.playerName = details.playerName;
        lastPayload.contactMethod = details.contactMethod;
        lastPayload.contact = details.contact;
      }

      if (!endpoint || endpoint.indexOf('YOUR-WORKER') !== -1) {
        throw new Error('Order API is not configured yet.');
      }

      refreshWhatsApp(lastPayload, lastClientOrderId);
      showOnly('loading');

      var response = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/json',
          'X-RSS-Order-Id': lastClientOrderId
        },
        body: JSON.stringify({
          clientOrderId: lastClientOrderId,
          qty: lastPayload.qty,
          packageLabel: lastPayload.label,
          source: lastPayload.source,
          server: lastPayload.server,
          playerName: lastPayload.playerName,
          contactMethod: lastPayload.contactMethod,
          contact: lastPayload.contact,
          pageUrl: window.location.href
        })
      });

      var result = {};

      try {
        result = await response.json();
      } catch (jsonError) {}

      if (!response.ok || result.ok !== true) {
        throw new Error(
          result.error ||
            'We could not save the order. Please try again.'
        );
      }

      renderSuccess(lastPayload, lastClientOrderId, result);
    } catch (error) {
      renderError(
        error && error.message
          ? error.message
          : 'We could not save the order.'
      );
    } finally {
      busy = false;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(
        '[data-rss-continue], [data-rss-order-continue], [data-rss-submit-order]'
      );

      if (!trigger) return;
      if (trigger.disabled === true) return;

      event.preventDefault();
      event.stopPropagation();

      lastTrigger = trigger;
      prepareOrder(trigger);
    },
    true
  );

  if (detailsForm) {
    detailsForm.addEventListener('submit', function (event) {
      event.preventDefault();
      sendOrder(false);
    });
  }

  if (contactMethodInput) {
    contactMethodInput.addEventListener(
      'change',
      updateContactInput
    );
  }

  modal
    .querySelectorAll('[data-rss-order-close]')
    .forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

  modal.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeModal();
  });

  if (retryButton) {
    retryButton.addEventListener('click', function () {
      sendOrder(true);
    });
  }

  window.RSSOrderAuto = {
    submit: function () {
      lastTrigger = null;
      prepareOrder(null);
    },
    close: closeModal
  };
})();
